
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"95","height":"22","viewBox":"0 0 95 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.712 16.369h-8.2l10.47-14.69a.776.776 0 00-.14-1.034.666.666 0 00-.418-.148H26.276c-1.33 0-2.42 1.156-2.42 2.567 0 1.411 1.09 2.567 2.42 2.567h6.807L22.575 20.334a.763.763 0 00.127 1.034.587.587 0 00.43.148H39.7c1.33-.067 2.357-1.276 2.294-2.701-.063-1.317-1.052-2.365-2.294-2.433v-.013h.012zM92.645.497c-1.33 0-2.42 1.156-2.42 2.567v8.615L77.142.672a.663.663 0 00-.976.107.768.768 0 00-.152.47v17.7c0 1.411 1.09 2.567 2.421 2.567 1.331 0 2.421-1.142 2.421-2.567v-8.614l13.081 11.02a.678.678 0 00.989-.121.758.758 0 00.152-.457V3.064C95.066 1.64 93.989.497 92.645.497zM58.03 16.853c-5.54 0-9.672-3.091-9.672-5.86 0-2.768 4.145-5.86 9.672-5.86 5.539 0 9.67 3.092 9.67 5.86 0 2.769-4.119 5.86-9.67 5.86zm0-16.853c-8.011 0-14.514 4.919-14.514 10.993 0 6.075 6.503 10.994 14.514 10.994 8.01 0 14.513-4.92 14.513-10.994S66.039 0 58.028 0zM10.38 16.866c-3.055 0-5.539-2.62-5.539-5.86 0-3.238 2.472-5.872 5.527-5.872 3.054 0 5.539 2.62 5.539 5.86v.013c0 3.225-2.472 5.846-5.527 5.86zm0-16.866C4.651 0 .013 4.919 0 10.993 0 17.068 4.64 21.987 10.369 22c5.729 0 10.368-4.919 10.38-10.993v-.014C20.738 4.92 16.099 0 10.382 0z","fill":"#fff"}})])
          )
        }
      }
    